import {ContentfulSectionIntro} from '@github-ui/swp-core/components/contentful/ContentfulSectionIntro'
import {Image, Section} from '@primer/react-brand/esm'
import type {ResourcesSectionContent} from '../../content'
import {Cards} from '../../_components/Cards/Cards'
import {MonaDivider} from '../../../../../brand/components/MonaDivider'

import styles from './ResourcesSection.module.css'

type Props = {
  contentfulContent: ResourcesSectionContent
}

export function ResourcesSection({contentfulContent}: Props) {
  const sectionId = contentfulContent.section.fields.htmlId
  const sectionIntro = contentfulContent.sectionIntro
  const cards = contentfulContent.cards

  // Divider
  // Use `GenericContent` and a nested `GenericAsset` with an id of `showMonaDivider` to enable the WebGL MonaDivider.
  // Without, the GenericAsset's image will be used as fallback.

  const divider = contentfulContent.divider
  const dividerMedia = divider?.fields.media?.[0]
  const dividerAsset = dividerMedia?.fields.asset?.fields
  const dividerFile = dividerAsset?.file
  const showMonaDivider = dividerMedia?.fields.id === 'showMonaDivider'

  return (
    <Section id={sectionId} fullWidth paddingBlockEnd="none">
      {sectionIntro ? <ContentfulSectionIntro component={sectionIntro} /> : null}
      {cards ? <Cards component={cards} /> : null}

      {showMonaDivider || dividerFile ? (
        <Section as="div" variant="gridline" paddingBlockStart="none" paddingBlockEnd="none" data-padding-inline="0">
          {showMonaDivider ? (
            <MonaDivider colorVariant="pearl" />
          ) : dividerFile ? (
            <Image
              className={styles.Divider}
              src={dividerFile.url}
              width={dividerFile.details?.image?.width}
              height={dividerFile.details?.image?.height}
              alt={dividerAsset?.description || ''}
              loading="lazy"
            />
          ) : null}
        </Section>
      ) : null}
    </Section>
  )
}
